document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-catalog-filter]').forEach((root) => {
    const search = root.querySelector('[data-search]');
    const series = root.querySelector('[data-series-filter]');
    const model = root.querySelector('[data-model-filter]');
    const needle = root.querySelector('[data-needle-filter]');
    const sort = root.querySelector('[data-catalog-sort]');
    const reset = root.querySelector('[data-filter-reset]');
    const resultCount = root.querySelector('[data-result-count]');
    const cards = [...root.querySelectorAll('[data-catalog-item]')];
    const empty = root.querySelector('[data-empty]');
    const currentUrl = new URL(window.location.href);

    const restoreSelect = (select, parameter) => {
      const requested = currentUrl.searchParams.get(parameter);
      if (select && requested && [...select.options].some((option) => option.value === requested)) select.value = requested;
    };

    if (search && currentUrl.searchParams.get('catalog_q')) search.value = currentUrl.searchParams.get('catalog_q');
    restoreSelect(series, 'catalog_series');
    restoreSelect(model, 'catalog_model');
    restoreSelect(needle, 'catalog_needle');

    const syncFilterUrl = () => {
      const url = new URL(window.location.href);
      const q = (search?.value || '').trim();
      const s = series?.value || 'all';
      const m = model?.value || 'all';
      const n = needle?.value || 'all';
      q ? url.searchParams.set('catalog_q', q) : url.searchParams.delete('catalog_q');
      s !== 'all' ? url.searchParams.set('catalog_series', s) : url.searchParams.delete('catalog_series');
      m !== 'all' ? url.searchParams.set('catalog_model', m) : url.searchParams.delete('catalog_model');
      n !== 'all' ? url.searchParams.set('catalog_needle', n) : url.searchParams.delete('catalog_needle');
      url.searchParams.delete('catalog_filter');
      url.searchParams.delete('page');
      window.history.replaceState({}, '', url);
    };

    const apply = ({syncUrl = true} = {}) => {
      const q = (search?.value || '').trim().toLowerCase();
      const s = (series?.value || 'all').toLowerCase();
      const m = (model?.value || 'all').toLowerCase();
      const n = (needle?.value || 'all').toLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const searchText = card.dataset.searchText || '';
        const tagTokens = card.dataset.productTags || '';
        const optionTokens = card.dataset.productOptions || '';
        const matchesText = !q || searchText.includes(q);
        const matchesSeries = s === 'all' || tagTokens.includes(`|${s}|`);
        const matchesModel = m === 'all' || tagTokens.includes(`|${m}|`);
        const matchesNeedle = n === 'all' || optionTokens.includes(`|${n}|`);
        card.hidden = !(matchesText && matchesSeries && matchesModel && matchesNeedle);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.style.display = visible ? 'none' : 'grid';
      if (resultCount) resultCount.textContent = String(visible);
      if (reset) reset.hidden = !(q || s !== 'all' || m !== 'all' || n !== 'all');
      if (syncUrl) syncFilterUrl();
    };

    search?.addEventListener('input', apply);
    series?.addEventListener('change', apply);
    model?.addEventListener('change', apply);
    needle?.addEventListener('change', apply);
    reset?.addEventListener('click', () => {
      if (search) search.value = '';
      if (series) series.value = 'all';
      if (model) model.value = 'all';
      if (needle) needle.value = 'all';
      apply();
      search?.focus();
    });
    sort?.addEventListener('change', () => {
      const url = new URL(window.location.href);
      sort.value ? url.searchParams.set('sort_by', sort.value) : url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    apply({syncUrl: false});
  });

  document.querySelectorAll('.product-panel__description, .product-details .richtext').forEach((target) => {
    const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.textContent = node.textContent.replace(
        'M8S / A11 / A8S cartridge family',
        'M8S / A11 / A8S / A9 cartridge family',
      );
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[name="id"]');
    const price = form.closest('[data-product-panel]')?.querySelector('[data-current-price]');
    const compare = form.closest('[data-product-panel]')?.querySelector('[data-compare-price]');
    const mobilePrice = document.querySelector('[data-mobile-price]');
    const button = form.querySelector('[type="submit"]');
    const mobileButton = document.querySelector('[data-scroll-to-product]');
    const update = () => {
      const option = select?.selectedOptions?.[0];
      if (!option) return;
      if (price) price.textContent = option.dataset.price || '';
      if (mobilePrice) mobilePrice.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (button) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? button.dataset.availableText : button.dataset.soldOutText;
      }
      if (mobileButton) {
        mobileButton.disabled = option.dataset.available !== 'true';
        mobileButton.textContent = option.dataset.available === 'true' ? mobileButton.dataset.availableText : mobileButton.dataset.soldOutText;
      }
    };
    select?.addEventListener('change', update);
    update();
  });

  document.querySelectorAll('[data-scroll-to-product]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = document.querySelector('[data-product-panel]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel?.scrollIntoView({behavior: reduceMotion ? 'auto' : 'smooth'});
      panel?.querySelector('select, input, button')?.focus({preventScroll: true});
    });
  });

  document.querySelectorAll('[data-hero-media-toggle]').forEach((button) => {
    const video = button.closest('.hero')?.querySelector('video');
    if (!video) {
      button.hidden = true;
      return;
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      video.pause();
      button.textContent = 'Play video';
      button.setAttribute('aria-pressed', 'true');
    }
    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
        button.textContent = 'Pause video';
        button.setAttribute('aria-pressed', 'false');
      } else {
        video.pause();
        button.textContent = 'Play video';
        button.setAttribute('aria-pressed', 'true');
      }
    });
  });

  document.querySelectorAll('[data-verify-form]').forEach((form) => {
    const result = form.querySelector('[data-verify-result]');
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const endpoint = form.dataset.endpoint;
      const code = new FormData(form).get('code');
      result.style.display = 'block';
      if (!endpoint) {
        result.textContent = 'Security-code lookup is being connected. Please contact store support with your security code.';
        return;
      }
      result.textContent = 'Checking…';
      try {
        const response = await fetch(endpoint, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({code})});
        const data = await response.json();
        result.textContent = data.message || data.result || 'No verification result was returned.';
      } catch (_) {
        result.textContent = 'The verification service is temporarily unavailable. Please try again later.';
      }
    });
  });
});
